var _defs, _rect, _rect2, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullArtboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#408bc9;stroke-miterlimit:10;}.cls-2{fill:#408bc9;stroke-width:.95px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.7,
    y: 36.8,
    width: 10.44,
    height: 17.93,
    rx: 4.9,
    ry: 4.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 65.87,
    y: 36.8,
    width: 10.44,
    height: 17.93,
    rx: 4.9,
    ry: 4.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.69,37.39c-.03-17.3,14.22-31.41,31.23-31.31,16.65.1,30.55,13.8,30.84,30.72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.85,51.94c1.31,2.41,3.99,6.57,8.84,10.14,5.42,3.99,10.81,5.23,13.58,5.66"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.12,
    cy: 68.55,
    r: 5.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullArtboard);
export default __webpack_public_path__ + "static/media/FullArtboard.ff692104413b05410425f6fdbca2ca0c.svg";
export { ForwardRef as ReactComponent };